import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IntegrationRoutingModule } from './integration-routing.module';
import { IntegrationQbdQuoteModalComponent } from './integration-qbd-quote-modal/integration-qbd-quote-modal.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { UIModule } from 'app/ui/ui.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { IntegrationQboQuoteModalComponent } from './integration-qbo-quote-modal/integration-qbo-quote-modal.component';
import { IntegrationQboMatchPoLinesModalComponent } from './integration-qbo-match-po-lines-modal/integration-qbo-match-po-lines-modal.component';
import { IntegrationQboCreateItemModalComponent } from './integration-qbo-create-item-modal/integration-qbo-create-item-modal.component';
import { IntegrationAccountsSelectAssignmentModalComponent } from './integration-accounts-select-assignment-modal/integration-accounts-select-assignment-modal.component';
import { IntegrationAccountsLinkCustomerModalComponent } from './integration-accounts-link-customer-modal/integration-accounts-link-customer-modal.component';
import { IntegrationXeroMatchPoLinesModalComponent } from './integration-xero-match-po-lines-modal/integration-xero-match-po-lines-modal.component';

@NgModule({
	declarations: [
		IntegrationQbdQuoteModalComponent,
		IntegrationQboQuoteModalComponent,
		IntegrationQboMatchPoLinesModalComponent,
		IntegrationQboCreateItemModalComponent,
		IntegrationAccountsSelectAssignmentModalComponent,
		IntegrationAccountsLinkCustomerModalComponent,
		IntegrationXeroMatchPoLinesModalComponent
	],
	imports: [
		CommonModule,
		IntegrationRoutingModule,
		FormsModule,
		SharedModule,
		UIModule,
		NgbModule
	],
	exports: [
		IntegrationQbdQuoteModalComponent,
		IntegrationQboQuoteModalComponent,
		IntegrationQboMatchPoLinesModalComponent,
		IntegrationQboCreateItemModalComponent,
		IntegrationAccountsSelectAssignmentModalComponent,
		IntegrationAccountsLinkCustomerModalComponent,
		IntegrationXeroMatchPoLinesModalComponent
	]
})
export class IntegrationModule { }
